import {
    AdvancedWorkflowDetailsConfiguration,
    FormattedAdvancedWorkflowDetailsConfiguration
} from "@idw-types/data/workflow-details-configuration";
import { AxnAvailablePropertyCategory, AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { formatAppliedProfiles } from "../applied-profiles/applied-profiles-formatter";
import { extractAvailablePropertiesFromCategories } from "@utils/available-properties-util";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export const formatAdvancedWorkflowDetailsConfiguration = (
    advancedWorkflowDetailsConfiguration: AdvancedWorkflowDetailsConfiguration,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnCompanies: Array<AxnCompany>,
    axnAvailablePropertyCategories: Array<AxnAvailablePropertyCategory>,
    rpServices: Array<FormattedRpServiceConfiguration>
): FormattedAdvancedWorkflowDetailsConfiguration => {

    const { workflow } = advancedWorkflowDetailsConfiguration;
    const availableProperties = extractAvailablePropertiesFromCategories(axnAvailablePropertyCategories);

    const company = axnCompanies.find(c => c.id === workflow.companyID);

    const relyingParty = axnRelyingParties.find(rp => rp.id === `${workflow.relyingPartyID}`);

    const appliedProfiles = formatAppliedProfiles(
        (advancedWorkflowDetailsConfiguration.workflow.appliedProfiles || []),
        axnCompanies,
        availableProperties,
        true // shouldPopulateMissingProperties
    );

    return {
        workflow: {
            company: company,
            hasDCUIService: workflow.hasDCUIService,
            id: workflow.id,
            name: workflow.name,
            permissions: workflow.permissions,
            relyingParty: relyingParty,
            rpServiceWorkflows: workflow.rpServiceWorkflows,
            sku: typeof workflow.sku === "undefined" ? null : workflow.sku,
            status: workflow.status,
            workflowKey: workflow.workflowKey,
            workflowVariants: workflow.workflowVariants,
            appliedProfiles: appliedProfiles
        },
        rpServices
    };
};